<template>
  <AccountNavButton
    :userGreeting="userGreeting"
    :show-customer-name="showCustomerName"
    :rewardsBalance="rewardsBalance"
  />
</template>

<script>
import { AccountNavButton } from '@rei/account-flyout';
import { ref } from 'vue';

export default {
  name: 'AccountNavComponent',
  components: { AccountNavButton },
  props: {
    user: {
      type: Object,
      default: null,
    },
  },
  computed: {
    userGreeting() {
      return this.user && this.user.contact && this.user.contact.firstName && this.showCustomerName
        ? `Hi, ${this.user.contact.firstName}`
        : 'My Account';
    },
    rewardsBalance() {
      if (this.user && this.user.membership && this.user.membership.dividendBalance != null) {
        const {
          membership: { dividendBalance },
        } = this.user;
        const balance = parseFloat(dividendBalance);
        const formattedBalance = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        }).format(balance);
        return formattedBalance === '$0.00' ? '' : `${formattedBalance}`;
      }
      return '';
    },
  },
  setup() {
    const showCustomerName = ref(false);
    function displayCustomerName() {
      showCustomerName.value = true;
      // Replace mobile menu default text when user is logged in
      // also allows user to log out on mobile screen sizes
      /* TODO: pull this out into account-flyout package */
      const loginButton = document.querySelector('li[data-js="mobile-nav-login-link"]');
      if (loginButton) {
        loginButton.innerHTML = `<div class="account-link-mobile-container">
                                      <a class="account-link" href="/YourAccountInfoInView" data-ui=nav-level-1" data-analytics-id="rei_nav:account" rel="nofollow">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" data-visible="mobile" class="gnav-icon" aria-hidden="true"> <use xlink:href="#account-profile"></use> </svg>
                                        <div class="account-link-info-container">
                                          <span class="account-link__text" data-icon="left">${
                                            this.userGreeting
                                          }</span>
                                          ${
                                            this.rewardsBalance
                                              ? `<span class="account-link__text account-link__rewards-wrapper" data-icon="left">
                                                  Rewards:
                                                  <span class="account-link__rewards-span">${this.rewardsBalance}</span>
                                                </span>`
                                              : ''
                                          }
                                        </div>
                                      </a>
                                    <a class="account-link account-link--right" href="/youraccount/logout" data-ui="nav-level-1" data-analytics-id="rei_nav:sign_out" rel="nofollow">
                                      <span class="account-link__text">Sign Out</span>
                                    </a>
                                  </div>`;
      }
    }
    return { showCustomerName, displayCustomerName };
  },
  mounted() {
    this.displayCustomerName();
  },
};
</script>

<style lang="scss" scoped></style>
